import {PlatformNavbarMenuItem} from '@flexinet/ui-components';
import {AiOutlineUser} from 'react-icons/ai';
import {IconContext} from 'react-icons';
import {rbacActions} from '../../../config/rbac/actions';
import usersConfig from '../../../features/users/config';

// Sidebar menu items. PortalNavbar keeps only the items whose `rbac` action is
// in the user's allowedActions, so `rbac` must name an action declared in
// config/rbac/actions.ts AND the same action the page it opens checks.
// Users' index page is gated on ListUsers in features/users/layout.tsx.
export const getMenuItems = (): PlatformNavbarMenuItem[] => [
    {
        id: 'users',
        link: usersConfig.basePath,
        label: 'Users',
        icon: (
            <IconContext.Provider value={{size: '2em'}}>
                <AiOutlineUser/>
            </IconContext.Provider>
        ),
        rbac: rbacActions.ListUsers,
    },
];
